import { schema } from 'normalizr';
import { CALL_API } from '../middleware/api';

// ACTIONS
export const EVENTS_FETCH_REQUEST = 'events/EVENTS_FETCH_REQUEST';
export const EVENTS_FETCH_SUCCESS = 'events/EVENTS_FETCHED_SUCCESS';
export const EVENTS_FETCH_ERROR = 'events/EVENTS_FETCHED_ERROR';


// REDUCER
export default function reducer(state = {
  entities: null,
  result: null,
  current: null,
  fetching: false,
  fetched: false,
  error: null,
}, action) {
  switch (action.type) {
    case EVENTS_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case EVENTS_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        entities: action.payload.entities.events,
        result: action.payload.result,
      };

    case EVENTS_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
  }

  return state;
}

// Schemas
export const eventSchema = new schema.Entity('events');

// Operations
export function fetchEvents(params) {
  return {
    [CALL_API]: {
      types: [EVENTS_FETCH_REQUEST, EVENTS_FETCH_SUCCESS, EVENTS_FETCH_ERROR],
      promise: httpClient => httpClient.post('/lockers/paketbox/event', params),
      schema: { data: [eventSchema] },
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/events.js